module.exports = __webpack_public_path__ + "static/media/03-Leipzig.465136ab.jpg";